import { GridItem } from "@certn/cascadia-react";
import { S3FileInfo } from "@certn/cascadia-react/deprecated/upload/types";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { useField } from "formik";
import { useState } from "react";
import { useParams } from "react-router-dom";

import {
  ApplicantDocumentUpload,
  convertDocumentToS3FileInfo,
} from "../../../../components/ApplicantDocumentUpload";

export function ProofOfAddressInputField({
  field: config,
}: {
  field: components["schemas"]["ProofOfAddressCheckField"];
}) {
  const [files, setFiles] = useState<S3FileInfo[]>(() =>
    config.value ? [convertDocumentToS3FileInfo(config.value)] : []
  );
  const { applicantId } = useParams();
  const [, meta, helpers] = useField(config.name);

  const handleFilesChange = (files: S3FileInfo[]) => {
    helpers.setValue(files[0] ? { id: files[0].document.document_id } : null);
    setFiles(files);
  };

  return (
    <GridItem>
      <ApplicantDocumentUpload
        isRequired
        documentType="PROOF_OF_ADDRESS"
        applicantId={applicantId ?? ""}
        files={files}
        setFiles={handleFilesChange}
        error={meta.error}
        testID="proof-of-address-document-upload-button"
      />
    </GridItem>
  );
}
